import { BRAND, isMarketGB } from 'src/constants/main';
import { VehicleDetailsHeadingInformationStyled } from './VehicleDetailsHeadingInformationStyled';
import { SC } from 'src/styles/theme';
import React from 'react';
import { VehicleDetailsHeadingInformationStyledAC } from './AC/VehicleDetailsHeadingInformationStyledAC';
import { VehicleDetailsHeadingInformationStyledAP } from './AP/VehicleDetailsHeadingInformationStyledAP';
import { VehicleDetailsHeadingInformationStyledDS } from './DS/VehicleDetailsHeadingInformationStyledDS';
import { VehicleDetailsHeadingInformationStyledOV } from './OV/VehicleDetailsHeadingInformationStyledOV';
import { VehicleDetailsHeadingInformationStyledOVGB } from './OV/VehicleDetailsHeadingInformationStyledOVGB';

export interface VehicleDetailsHeadingInformationProps extends SC {
    onClick: () => void;
}

export const VehicleDetailsHeadingInformation = (props: VehicleDetailsHeadingInformationProps) => {
    if (BRAND === 'AC') return <VehicleDetailsHeadingInformationStyledAC {...props} />;
    if (BRAND === 'AP') return <VehicleDetailsHeadingInformationStyledAP {...props} />;
    if (BRAND === 'DS') return <VehicleDetailsHeadingInformationStyledDS {...props} />;
    if (BRAND === 'OV')
        return isMarketGB ? (
            <VehicleDetailsHeadingInformationStyledOVGB {...props} />
        ) : (
            <VehicleDetailsHeadingInformationStyledOV {...props} />
        );
    return <VehicleDetailsHeadingInformationStyled {...props} />;
};

export default VehicleDetailsHeadingInformation;
